import { Component } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: 'child-cell',
    template: `<span><button style="height: 15px; font-size:12px; padding:2px 5px 2px 5px" (click)="invokeParentMethod()" class="btn btn-primary">Details</button></span>`,
    styles: [
        `.btn {
            line-height: 0.5
        }`
    ]
})
export class ChildSearchByEidComponent implements ICellRendererAngularComp  {

  public params: any;


  agInit(params: any): void {
    this.params = params;
  }

  invokeParentMethod() {
    this.params.context.componentParent.methodFromParent(
      this.params.data.PRARequestID
      );
  }

  refresh(): boolean {
    return false;
  }

}
